import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FirebaseNotificationService {
  private fcmToken: string | null = null;

  constructor(private http: HttpClient) {}

  async init(): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;

    try {
      const { receive } = await FirebaseMessaging.requestPermissions();
      if (receive !== 'granted') {
        console.warn('Notification permission denied');
        return;
      }

      await LocalNotifications.requestPermissions();

      if (Capacitor.getPlatform() === 'android') {
        await LocalNotifications.createChannel({
          id: 'default',
          name: 'Default Notifications',
          importance: 5,
          visibility: 1,
          sound: 'default',
          vibration: true,
          lights: true,
        });
      }

      const { token } = await FirebaseMessaging.getToken();
      this.fcmToken = token;
      console.log('FCM Token OK:', token);

      // When app is open, show as a local notification banner.
      // No `schedule` — an immediate notification must not go through
      // AlarmManager (exact alarms are denied by default on Android 14+).
      // id must fit in a Java 32-bit int, so Date.now() is too large.
      await FirebaseMessaging.addListener('notificationReceived', async (event) => {
        const n = event.notification;
        await LocalNotifications.schedule({
          notifications: [{
            id: Math.floor(Math.random() * 2147483647),
            title: n.title ?? 'Uzhavar App',
            body: n.body ?? '',
            sound: 'default',
            channelId: 'default',
          }],
        });
      });

      await FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
        console.log('Notification tapped:', event.notification);
      });

    } catch (e: any) {
      console.error('FCM init error:', e?.message || e);
    }
  }

  getToken(): string | null {
    return this.fcmToken;
  }

  async sendTestNotification(): Promise<void> {
    if (!this.fcmToken) await this.init();

    if (!this.fcmToken) {
      alert('FCM token not available.\n\nMake sure:\n1. google-services.json is in android/app/\n2. App is built and installed after adding it');
      return;
    }

    this.http.post(`${environment.DHARSTEC_URL}notification/send`, {
      token: this.fcmToken,
      title: 'Uzhavar App',
      body: 'Test push notification',
    }).subscribe({
      next: () => alert('Test notification sent — it should appear in a few seconds.'),
      error: (e) => alert('Send failed: ' + (e?.error?.message || e?.message || 'server unreachable')),
    });
  }
}
